// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container-logo[data-v-7f53e496] {\r\n  flex-direction: column;\n}\n.size_icon[data-v-7f53e496] {\r\n  width: 30%;\r\n  max-width: 200px;\r\n  text-align: center;\n}\r\n", ""]);
// Exports
module.exports = exports;
